<template>
  <div class="page-container users-container">
    <todo-side-bar selected="users" />

    <h1>{{ $t('pages.users' ) }}</h1>

    <!--
    <div v-if="activeTabs === 'Customer'" class="users-export">
      <el-button type="info" round @click="exportToExcel">
        <svg-icon name="excel" />
        <span>{{ $t('providers.export') }}</span>
      </el-button>
    </div>
    -->
    <el-tabs>
      <el-tab-pane label="Customers" name="Customers" style="height: 100%">
        <todo-users role="Customer" />
      </el-tab-pane>
      <el-tab-pane label="ServiceProviders" name="ServiceProvider">
        <todo-users role="ServiceProvider" />
      </el-tab-pane>
      <el-tab-pane label="Services" name="Services">
        <todo-users role="Services" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { exportUsers } from '@/api/export'
  import TodoUsers from './components/Users.vue'

  export default {
    components: {
      'todo-users': TodoUsers
    },

    data() {
      return {
        activeTabs: 'ServiceProvider',
        exportRole: 'Customer'
      }
    },

    methods: {
      exportToExcel() {
        exportUsers(this.exportRole).then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', this.fileName(response))
          document.body.appendChild(fileLink)
          fileLink.click()
        })
      },

      fileName(response) {
        const disposition = response.headers['content-disposition']

        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/

          const matches = filenameRegex.exec(disposition)

          if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '')
          }
        }

        return 'customers.csv'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/variables';

  .users-container {
    .users-export {
      position: absolute;
      top: 107px;
      right: 80px;

      .el-button--info {
        padding: 7px 25px 7px 18px;

        .svg-icon {
          stroke-width: 1;
          color: black;
          width: 22px;
          height: 22px;
        }

        span {
          display: inline-block;
          padding-left: 12px;
          vertical-align: middle;
          font-size: 13px;
        }
      }
    }

    .users-tabs {
      margin-top: 30px;

      .el-tabs__header {
        display: inline-block;
      }

      .el-tabs__content {
        position: initial;
      }

      .el-tabs__nav-wrap::after {
        background: none;
      }

      .el-tabs__active-bar {
        background: none;
      }

      .el-tabs__item {
        padding: 10px 30px 11px 30px!important;
        background: $color-info;
        border-radius: 16px;
        margin-right: 20px;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        color: $color-text-regular;

        &.is-active {
          background: $color-primary;
          color: white;
        }
      }
    }
  }
</style>
